import * as React from 'react';

// HOC
import { withUserWebView } from '@shopee-user/with-web-view';

// Components
import { IconNotification20 } from '@nebula/icon';

// Hooks
import { useTranslation } from '@shopee-user/platform';

// Types
import { WithUserWebViewProps } from '@shopee-user/with-web-view';

// Styles
import styles from './style.scss';

type Props = {
  subject: string;
  onClickContactUs: () => void;
} & WithUserWebViewProps;
function AccountPageHelpFooter({ subject, onClickContactUs }: Props) {
  const I18n = useTranslation();

  return (
    <div className={styles.footer}>
      <IconNotification20 className={styles.icon} size={12} />
      <div className={styles.text}>
        {`${subject} `}
        {I18n.tNode('msg_account_please_contact_us_for_help', {
          contact_us: (
            <span
              className={styles.linkWithUnderline}
              onClick={onClickContactUs}
            >
              {I18n.t('msg_account_contact_us')}
            </span>
          ),
        })}
      </div>
    </div>
  );
}

export default withUserWebView({})(AccountPageHelpFooter);
